import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/router";
export const useToggle = () => {
  const $ = _c(4);
  const router = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      text: "\u0628\u0644\u06CC\u0637 + \u0627\u0642\u0627\u0645\u062A",
      value: "tour-flight",
      role: "next-link" as const,
      href: "/tour"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [t0, {
      text: "\u062A\u0648\u0631 \u06AF\u0631\u062F\u0634\u06AF\u0631\u06CC",
      value: "tour-group",
      role: "next-link" as const,
      href: "/tour?tour=tour-group"
    }];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const toggleList = t1;
  const toggleValue = router.pathname.startsWith("/group") || router.query.tour === "tour-group" ? "tour-group" : "tour-flight";
  let t2;
  if ($[2] !== toggleValue) {
    t2 = {
      toggleList,
      toggleValue
    };
    $[2] = toggleValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};